/* eslint-disable react/prop-types */
import { Formik } from 'formik';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// components
import AdditionalInfoBlock from './components/AdditionalInfo';
import EducationInfoBlock from './components/EducationInfoBlock';
import WorkExperienceBlock from './components/WorkExperienceBlock';
import DesiredPositionBlock from './components/DesiredPositionBlock';
import ContactInformationBlock from './components/ContactInformationBlock';
import PersonalInformationBlock from './components/PersonalInformationBlock';
// hooks
import { useWindowSize } from '../../../Hooks/use-window-size';
// mui
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const salaryFormat = /^\d*\.?\d+$/;
const nameFormat = /^[A-Za-zА-Яа-яіІїЇєЄыЫ]+$/;
const contactNumberFormat = /^\+\d{1,3}\d{6,14}$/;
const urlFormat = /^(https?|http|ftp):\/\/[^\s/$.?#].[^\s]*$/;
const urlFormatMap = {
  'LinkedIn': /^https:\/\/www\.linkedin\.com\//,
  'Facebook': /^https:\/\/www\.facebook\.com\//,
  'Twitter': /^https:\/\/x\.com\//,
  'Instagram': /^https:\/\/www\.instagram\.com\//,
  'GitHub': /^https:\/\/github\.com\//,
  'TikTok': /^https:\/\/www\.tiktok\.com\//,
};

// const PrimaryButton = ({
//   t,
//   id,
//   isCopy,
//   values,
//   isAdmin,
//   isValid,
//   onCreate,
//   isSubmitting,
// }) => {
//   const isCreateMode = !id || isCopy;

//   if (isAdmin) {
//     return (
//       <button
//         type='submit'
//         className='btn btn-primary button1'
//         disabled={!isValid || isSubmitting}
//       >
//         {t('jobseekerEditProfile.updateButton')}
//       </button>
//     );
//   }

//   if (isCreateMode) {
//     return (
//       <button
//         type='button'
//         onClick={() => onCreate(values)}
//         className='btn btn-primary button1'
//         disabled={!isValid || isSubmitting}
//       >
//         {t('jobseekerEditProfile.createCVButton')}
//       </button>
//     );
//   }

//   return (
//     <button
//       type='submit'
//       className='btn btn-primary button1'
//       disabled={!isValid || isSubmitting}
//     >
//       {t('jobseekerEditProfile.updateButton')}
//     </button>
//   );
// };

const JSEditProfileForm = ({
  id,
  step,
  isCopy,
  isAdmin,
  setStep,
  faculties,
  directories,
  profileBody,
  handleCreate,
  handleSubmit,
  setFaculties,
}) => {
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const { t } = useTranslation('global');

  const [formTabs, setFormTabs] = useState(1);

  const handlePrevious = () => {
    setFormTabs(formTabs - 1);
  };

  const handleNext = (errors, setFieldTouched) => {
    let hasErrors = false;

    if (formTabs === 1 && (
      errors.city ||
      errors.gender ||
      errors.country ||
      errors.birthday ||
      errors.last_name ||
      errors.first_name ||
      errors.middle_name
    )) {
      ['city', 'gender', 'country', 'birthday', 'last_name', 'first_name', 'middle_name'].forEach(field => {
        if (errors[field]) {
          setFieldTouched(field, true);
        }
      });

      hasErrors = true;
    } else if (formTabs === 2 && (
      errors.email_address ||
      errors.video_cv_link ||
      errors.contact_number ||
      errors.contact_number_2 ||
      errors.contact_number_3 ||
      (errors.social_links && errors.social_links.length > 0) ||
      (errors.messenger_links && errors.messenger_links.length > 0)

    )) {
      ['email_address', 'video_cv_link', 'contact_number', 'contact_number_2', 'contact_number_3'].forEach(field => {
        if (errors[field]) {
          setFieldTouched(field, true);
        }
      });

      if (errors.social_links && errors.social_links.length > 0) {
        errors.social_links.forEach((socialError, index) => {
          Object.keys(socialError).forEach(field => {
            setFieldTouched(`social_links[${index}].${field}`, true);
          });
        });
      }

      if (errors.messenger_links && errors.messenger_links.length > 0) {
        errors.messenger_links.forEach((messengerError, index) => {
          Object.keys(messengerError).forEach(field => {
            setFieldTouched(`messenger_links[${index}].${field}`, true);
          });
        });
      }

      hasErrors = true;
    } else if (formTabs === 3 && (
      errors.position ||
      errors.work_type ||
      errors.salary_max ||
      errors.salary_min ||
      errors.desired_country ||
      errors.salary_currency ||
      (errors.relocations && errors.relocations.length > 0) ||
      (errors.desired_category && errors.desired_category.length > 0)
    )) {
      ['position', 'work_type', 'salary_max', 'salary_min', 'relocations', 'desired_country', 'salary_currency'].forEach(field => {
        if (errors[field]) {
          setFieldTouched(field, true);
        }
      });

      if (errors.desired_category && errors.desired_category.length > 0) {
        errors.desired_category.forEach((categoryError, index) => {
          Object.keys(categoryError).forEach(field => {
            setFieldTouched(`desired_category[${index}].${field}`, true);
          });
        });
      }

      hasErrors = true;
    } else if (formTabs === 4 && errors.experiences && errors.experiences.length > 0) {
      if (errors.experiences && errors.experiences.length > 0) {
        errors.experiences.forEach((experienceError, index) => {
          Object.keys(experienceError).forEach(field => {
            setFieldTouched(`experiences[${index}].${field}`, true);
          });
        });
      }

      hasErrors = true;
    } else if (formTabs === 5 && (
      (errors.educations && errors.educations.length > 0) ||
      (errors.additional_educations && errors.additional_educations.length > 0)
    )) {
      if (errors.educations && errors.educations.length > 0) {
        errors.educations.forEach((educationError, index) => {
          Object.keys(educationError).forEach(field => {
            setFieldTouched(`educations[${index}].${field}`, true);
          });
        });
      }

      if (errors.additional_educations && errors.additional_educations.length > 0) {
        errors.additional_educations.forEach((addEducationError, index) => {
          Object.keys(addEducationError).forEach(field => {
            setFieldTouched(`additional_educations[${index}].${field}`, true);
          });
        });
      }

      hasErrors = true;
    }

    if (hasErrors) {
      if (width >= 768) {
        window.scrollTo({ top: 350, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 650, behavior: 'smooth' });
      }

      return;
    }

    setFormTabs(formTabs + 1);
  };

  const {
    city = '',
    gender = '',
    skills = [],
    country = '',
    birthday = '',
    position = '',
    languages = [],
    last_name = '',
    work_type = '',
    educations = [],
    first_name = '',
    salary_max = '',
    salary_min = '',
    visibility = '',
    experiences = [],
    middle_name = '',
    relocations = [],
    social_links = [],
    email_address = '',
    video_cv_link = '',
    about_yourself = '',
    contact_number = '',
    driver_license = '',
    desired_country = '',
    driver_category = [],
    messenger_links = [],
    salary_currency = '',
    contact_number_2 = '',
    contact_number_3 = '',
    desired_category = [],
    company_blacklist = [],
    company_whitelist = [],
    additional_educations = [],
  } = profileBody;

  const initialValues = {
    city: city || '',
    gender: gender || '',
    country: country || 5,
    birthday: birthday || '',
    position: position || '',
    last_name: last_name || '',
    work_type: work_type || '',
    first_name: first_name || '',
    salary_max: salary_max || '',
    salary_min: salary_min || '',
    middle_name: middle_name || '',
    email_address: email_address || '',
    video_cv_link: video_cv_link || '',
    about_yourself: about_yourself || '',
    contact_number: contact_number || '',
    driver_license: driver_license || '',
    desired_country: desired_country || '',
    salary_currency: salary_currency || '',
    contact_number_2: contact_number_2 || '',
    contact_number_3: contact_number_3 || '',
    skills: skills?.length > 0 ? skills : [],
    relocations: relocations?.length > 0 ? relocations : [],
    driver_category: driver_category?.length > 0 ? driver_category : [],
    company_blacklist: company_blacklist?.length > 0 ? company_blacklist : [],
    company_whitelist: company_whitelist?.length > 0 ? company_whitelist : [],
    languages: languages?.length > 0 ? languages : [{ lng: '', lng_skill: '' }],
    social_links: social_links?.length > 0 ? social_links : [{ link: '', type: '' }],
    visibility: visibility || { value: '3', label: 'Видно тільки авторизованим компаніям' },
    messenger_links: messenger_links?.length > 0 ? messenger_links : [{ link: '', type: '' }],
    desired_category: desired_category?.length > 0 ? desired_category : [{ category: '', sub_category: [] }],
    additional_educations: additional_educations?.length > 0 ? additional_educations : [{
      certificate: '',
      course_link: '',
      course_name: '',
      diploma_type: '',
      institution_add: '',
      to_year_edu_add: '',
      to_month_edu_add: '',
      from_year_edu_add: '',
      from_month_edu_add: '',
      still_learning_add: '',
    }],
    educations: educations?.length > 0 ? educations : [{
      faculty: '',
      edu_type: '',
      specialty: '',
      institution: '',
      to_year_edu: '',
      to_month_edu: '',
      from_year_edu: '',
      still_learning: 0,
      from_month_edu: '',
    }],
    experiences: experiences?.length > 0 ? experiences : [{
      exp_city: '',
      industry: [],
      position: '',
      exp_country: 5,
      to_year_exp: '',
      achievements: '',
      organization: '',
      still_working: 0,
      to_month_exp: '',
      from_year_exp: '',
      from_month_exp: '',
    }],
  };

  const validate = ({
    city = '',
    gender = '',
    country = '',
    birthday = '',
    position = '',
    languages = [],
    last_name = '',
    work_type = '',
    educations = [],
    first_name = '',
    salary_max = '',
    salary_min = '',
    visibility = {},
    experiences = [],
    middle_name = '',
    relocations = '',
    social_links = [],
    video_cv_link = '',
    // about_yourself = '',
    contact_number = '',
    driver_license = '',
    desired_country = '',
    driver_category = [],
    messenger_links = [],
    salary_currency = '',
    contact_number_2 = '',
    contact_number_3 = '',
    desired_category = [],
    company_blacklist = [],
    company_whitelist = [],
    additional_educations = [],
  }) => {
    const newErrors = {
      messenger_links: messenger_links.reduce((acc, item, index) => {
        const fieldErrors = {};

        if (!item.type && item.link) {
          fieldErrors.type = t('jobseekerEditProfile.messengerTypeRequired', { index: index + 1 });
        }
        if (item.type && !item.link) {
          if (item.type === 'Telegram') {
            fieldErrors.link = t('jobseekerEditProfile.messengerLinkRequired', { index: index + 1 });
          } else if (['WhatsApp', 'Viber', 'Signal'].includes(item.type)) {
            fieldErrors.link = t('jobseekerEditProfile.messengerContactNumberRequired', { index: index + 1 });
          } else if (['Skype', 'Discord'].includes(item.type)) {
            fieldErrors.link = t('jobseekerEditProfile.messengerNameRequired', { index: index + 1 });
          }
        }
        if (item.link) {
          if (['WhatsApp', 'Viber', 'Signal'].includes(item.type) && !contactNumberFormat.test(item.link)) {
            fieldErrors.link = t('jobseekerEditProfile.contactNumberValidation', { index: index + 1 });
          }
          if (['Telegram', 'Skype', 'Discord'].includes(item.type) && urlFormat.test(item.link)) {
            fieldErrors.link = t('jobseekerEditProfile.messengerNicknameInvalid', { index: index + 1 });
          }
        }
        if (Object.keys(fieldErrors).length > 0) {
          acc[index] = fieldErrors;
        }

        return acc;
      }, []),

      social_links: social_links.reduce((acc, item, index) => {
        const fieldErrors = {};

        if (!item.type && item.link) {
          fieldErrors.type = t('jobseekerEditProfile.socialTypeRequired', { index: index + 1 });
        }
        if (item.type) {
          if (!item.link) {
            fieldErrors.link = t('jobseekerEditProfile.socialLinkRequired', { index: index + 1 });
          } else {
            const selectedSocialFormat = urlFormatMap[item.type];

            if (selectedSocialFormat && !selectedSocialFormat.test(item.link)) {
              fieldErrors.link = t('jobseekerEditProfile.socialLinkValidation', { index: index + 1, type: item.type });
            }
          }
        }
        if (Object.keys(fieldErrors).length > 0) {
          acc[index] = fieldErrors;
        }

        return acc;
      }, []),

      desired_category: desired_category.reduce((acc, item, index) => {
        const fieldErrors = {};

        if (!item.category) {
          fieldErrors.category = t('jobseekerEditProfile.categoryRequired', { index: index + 1 });
        }
        if (item.sub_category == '') {
          fieldErrors.sub_category = t('jobseekerEditProfile.subCategoryRequired', { index: index + 1 });
        }
        if (Object.keys(fieldErrors).length > 0) {
          acc[index] = fieldErrors;
        }

        return acc;
      }, []),

      experiences: experiences.reduce((acc, item, index) => {
        const fieldErrors = {};

        if (item.position == '') {
          fieldErrors.position = t('jobseekerEditProfile.positionRequired', { index: index + 1 });
        }
        if (item.organization == '') {
          fieldErrors.organization = t('jobseekerEditProfile.organizationRequired', { index: index + 1 });
        }
        if (item.industry == '') {
          fieldErrors.industry = t('jobseekerEditProfile.industryRequired', { index: index + 1 });
        }
        if (item.exp_country == '') {
          fieldErrors.exp_country = t('jobseekerEditProfile.countryRequired', { index: index + 1 });
        }
        if (item.from_month_exp == '') {
          fieldErrors.from_month_exp = t('jobseekerEditProfile.monthRequired', { index: index + 1 });
        }
        if (item.from_year_exp == '') {
          fieldErrors.from_year_exp = t('jobseekerEditProfile.yearRequired', { index: index + 1 });
        }
        if (item.to_month_exp == '' && !item.still_working) {
          fieldErrors.to_month_exp = t('jobseekerEditProfile.monthRequired', { index: index + 1 });
        }
        if (item.to_year_exp == '' && !item.still_working) {
          fieldErrors.to_year_exp = t('jobseekerEditProfile.yearRequired', { index: index + 1 });
        }
        if (item.achievements == '' || item.achievements == '<p><br></p>') {
          fieldErrors.achievements = t('jobseekerEditProfile.achievementsRequired', { index: index + 1 });
        }
        if (
          item.to_year_exp && item.to_month_exp &&
          (parseInt(item.from_year_exp) > parseInt(item.to_year_exp) ||
          (parseInt(item.from_year_exp) === parseInt(item.to_year_exp) &&
          parseInt(item.from_month_exp) >= parseInt(item.to_month_exp)))
        ) {
          fieldErrors.to_month_exp = t('jobseekerEditProfile.endDateMustBeAfterStartDate', { index: index + 1 });
        }
        if (Object.keys(fieldErrors).length > 0) {
          acc[index] = fieldErrors;
        }

        return acc;
      }, []),

      educations: educations.reduce((acc, item, index) => {
        const fieldErrors = {};

        if (item.edu_type == '') {
          fieldErrors.edu_type = t('jobseekerEditProfile.educationalDegreeRequired', { index: index + 1 });
        }
        if (item.institution == '' || item.institution == null) {
          fieldErrors.institution = t('jobseekerEditProfile.institutionRequired', { index: index + 1 });
        }
        if (faculties[index] != '' && item.edu_type !== '7' && item.edu_type !== '8' && item.faculty == '') {
          fieldErrors.faculty = t('jobseekerEditProfile.facultyRequired', { index: index + 1 });
        }
        // if (item.institution != '' && item.edu_type !== '7' && item.specialty == '') {
        //   fieldErrors.specialty = t('jobseekerEditProfile.specialtyRequired', { index: index + 1 });
        // }
        // if (item.from_month_edu == '') {
        //   fieldErrors.from_month_edu = t('jobseekerEditProfile.monthRequired', { index: index + 1 });
        // }
        if (item.from_year_edu == '') {
          fieldErrors.from_year_edu = t('jobseekerEditProfile.yearRequired', { index: index + 1 });
        }
        // if (item.to_month_edu == '' && !item.still_learning) {
        //   fieldErrors.to_month_edu = t('jobseekerEditProfile.monthRequired', { index: index + 1 });
        // }
        if (item.to_year_edu == '' && !item.still_learning) {
          fieldErrors.to_year_edu = t('jobseekerEditProfile.yearRequired', { index: index + 1 });
        }
        if (
          item.to_year_edu && item.to_month_edu &&
          (parseInt(item.from_year_edu) > parseInt(item.to_year_edu) ||
          (parseInt(item.from_year_edu) === parseInt(item.to_year_edu) &&
          parseInt(item.from_month_edu) >= parseInt(item.to_month_edu)))
        ) {
          fieldErrors.to_month_edu = t('jobseekerEditProfile.endDateMustBeAfterStartDate', { index: index + 1 });
        }
        if (Object.keys(fieldErrors).length > 0) {
          acc[index] = fieldErrors;
        }

        return acc;
      }, []),

      additional_educations: additional_educations.reduce((acc, item, index) => {
        const fieldErrors = {};
        const fileInput = document.querySelector(`[name="certificate_${index}"]`);

        if (item.course_name && item.course_name.trim().length > 512) {
          fieldErrors.course_name = t('jobseekerEditProfile.textMaxLength512', { index: index + 1 });
        }
        if (item.institution_add && item.institution_add.trim().length > 128) {
          fieldErrors.institution_add = t('jobseekerEditProfile.textMaxLength128', { index: index + 1 });
        }
        if (item.diploma_type && item.diploma_type.trim().length > 128) {
          fieldErrors.diploma_type = t('jobseekerEditProfile.textMaxLength128', { index: index + 1 });
        }
        if (item.course_link && !urlFormat.test(item.course_link.trim())) {
          fieldErrors.course_link = t('jobseekerEditProfile.urlInvalid', { index: index + 1 });
        } else if (item.course_link && item.course_link.trim().length > 255) {
          fieldErrors.course_link = t('jobseekerEditProfile.textMaxLength', { index: index + 1 });
        }
        if (fileInput && fileInput.files.length > 0 && fileInput.files[0].size >= 5 * 1024 * 1024) {
          fieldErrors.certificate = t('jobseekerEditProfile.maxFileSize', { index: index + 1 });
        }
        if ((item.from_month_edu_add || item.from_year_edu_add) && !item.from_month_edu_add) {
          fieldErrors.from_month_edu_add = t('jobseekerEditProfile.monthRequired', { index: index + 1 });
        }
        if ((item.from_month_edu_add || item.from_year_edu_add) && !item.from_year_edu_add) {
          fieldErrors.from_year_edu_add = t('jobseekerEditProfile.yearRequired', { index: index + 1 });
        }
        if (
          ((item.to_month_edu_add || item.to_year_edu_add) && !item.to_month_edu_add && !item.still_learning_add) ||
          ((item.from_month_edu_add || item.from_year_edu_add) && !item.to_month_edu_add && !item.still_learning_add)
        ) {
          fieldErrors.to_month_edu_add = t('jobseekerEditProfile.monthRequired', { index: index + 1 });
        }
        if (
          ((item.to_month_edu_add || item.to_year_edu_add) && !item.to_year_edu_add && !item.still_learning_add) ||
          ((item.from_month_edu_add || item.from_year_edu_add) && !item.to_year_edu_add && !item.still_learning_add)
        ) {
          fieldErrors.to_year_edu_add = t('jobseekerEditProfile.yearRequired', { index: index + 1 });
        }
        if (
          item.from_year_edu_add && item.from_month_edu_add && item.to_year_edu_add && item.to_month_edu_add &&
          (parseInt(item.from_year_edu_add) > parseInt(item.to_year_edu_add) || (
            parseInt(item.from_year_edu_add) === parseInt(item.to_year_edu_add) &&
            parseInt(item.from_month_edu_add) >= parseInt(item.to_month_edu_add)
          ))
        ) {
          fieldErrors.to_month_edu_add = t('jobseekerEditProfile.endDateMustBeAfterStartDate', { index: index + 1 });
        }
        if (Object.keys(fieldErrors).length > 0) {
          acc[index] = fieldErrors;
        }

        return acc;
      }, []),

      languages: languages.reduce((acc, item, index) => {
        const fieldErrors = {};

        if (!item.lng && item.lng_skill) {
          fieldErrors.lng = t('jobseekerEditProfile.lngRequired', { index: index + 1 });
        }
        if (item.lng && !item.lng_skill) {
          fieldErrors.lng_skill = t('jobseekerEditProfile.lngSkillRequired', { index: index + 1 });
        }
        if (Object.keys(fieldErrors).length > 0) {
          acc[index] = fieldErrors;
        }

        return acc;
      }, []),
    };

    const errorsArrays = ['languages', 'educations', 'experiences', 'social_links', 'messenger_links', 'desired_category', 'additional_educations'];

    if (first_name.trim() === '') {
      newErrors.first_name = t('jobseekerEditProfile.firstNameRequired');
    } else if (!nameFormat.test(first_name)) {
      newErrors.first_name = t('jobseekerEditProfile.textFormat');
    } else if (first_name.trim().length > 255) {
      newErrors.first_name = t('jobseekerEditProfile.textMaxLength');
    }
    if (last_name.trim() === '') {
      newErrors.last_name = t('jobseekerEditProfile.lastNameRequired');
    } else if (!nameFormat.test(last_name)) {
      newErrors.last_name = t('jobseekerEditProfile.textFormat');
    } else if (last_name.trim().length > 255) {
      newErrors.last_name = t('jobseekerEditProfile.textMaxLength');
    }
    if (middle_name) {
      if (!nameFormat.test(middle_name)) {
        newErrors.middle_name = t('jobseekerEditProfile.textFormat');
      } else if (middle_name.trim().length > 255) {
        newErrors.middle_name = t('jobseekerEditProfile.textMaxLength');
      }
    }
    if (!gender) {
      newErrors.gender = t('jobseekerEditProfile.genderRequired');
    }
    if (!birthday) {
      newErrors.birthday = t('jobseekerEditProfile.birthdayRequired');
    } else {
      const minDate = new Date('1930-01-01');
      const maxDate = new Date();
      const selectedDate = new Date(birthday);

      if (selectedDate < minDate) {
        newErrors.birthday = t('jobseekerEditProfile.birthdayTooEarly');
      } else if (selectedDate > maxDate) {
        newErrors.birthday = t('jobseekerEditProfile.birthdayTooLate');
      }
    }
    if (!country) {
      newErrors.country = t('jobseekerEditProfile.countryRequired');
    }
    if (!city) {
      newErrors.city = t('jobseekerEditProfile.cityRequired');
    }
    if (!contact_number) {
      newErrors.contact_number = t('jobseekerEditProfile.contactNumberRequired');
    } else if (!contactNumberFormat.test(contact_number)) {
      newErrors.contact_number = t('jobseekerEditProfile.contactNumberValidation');
    }
    if (contact_number_2 && !contactNumberFormat.test(contact_number_2)) {
      newErrors.contact_number_2 = t('jobseekerEditProfile.contactNumberValidation');
    }
    if (contact_number_3 && !contactNumberFormat.test(contact_number_3)) {
      newErrors.contact_number_3 = t('jobseekerEditProfile.contactNumberValidation');
    }
    if (video_cv_link && !urlFormat.test(video_cv_link.trim())) {
      newErrors.video_cv_link = t('jobseekerEditProfile.urlInvalid');
    }
    if (!position) {
      newErrors.position = t('jobseekerEditProfile.positionRequired');
    }
    if (!desired_country) {
      newErrors.desired_country = t('jobseekerEditProfile.countryRequired');
    }
    if (relocations.length === 0) {
      newErrors.relocations = t('jobseekerEditProfile.relocationsRequired');
    }
    if (salary_min && !salaryFormat.test(salary_min)) {
      newErrors.salary_min = t('jobseekerEditProfile.salaryNumeric');
    }
    if (salary_max) {
      if (!salaryFormat.test(salary_max)) {
        newErrors.salary_max = t('jobseekerEditProfile.salaryNumeric');
      }
      if (parseFloat(salary_max) < parseFloat(salary_min)) {
        newErrors.salary_max = t('jobseekerEditProfile.salaryMaxLowerSalaryMin');
      }
    }
    if (!salary_currency && (salary_min || salary_max)) {
      newErrors.salary_currency = t('jobseekerEditProfile.salaryCurrencyRequired');
    }
    if (!salary_currency && (salary_min || salary_max)) {
      newErrors.salary_currency = t('jobseekerEditProfile.salaryCurrencyRequired');
    }
    if (work_type.length === 0) {
      newErrors.work_type = t('jobseekerEditProfile.workTypeRequired');
    }
    // if (about_yourself == '' || about_yourself == '<p><br></p>') {
    //   newErrors.about_yourself = t('jobseekerEditProfile.descriptionRequired');
    // }
    if (driver_license && driver_category.length === 0) {
      newErrors.driver_category = t('jobseekerEditProfile.driverCategoryRequired');
    }
    if (visibility == '') {
      newErrors.visibility = t('jobseekerEditProfile.visibilityRequired');
    }
    if (visibility.value === 1 && company_whitelist.length === 0) {
      newErrors.company_whitelist = t('jobseekerEditProfile.organizationRequired');
    }
    if (visibility.value === 2 && company_blacklist.length === 0) {
      newErrors.company_blacklist = t('jobseekerEditProfile.organizationRequired');
    }

    errorsArrays.forEach(field => {
      if (Array.isArray(newErrors[field]) && newErrors[field].length === 0) {
        delete newErrors[field];
      }
    });

    return newErrors;
  };

  return (
    <Formik
      validate={validate}
      onSubmit={handleSubmit}
      enableReinitialize={false}
      initialValues={initialValues}
    >
      {({
        values,
        errors,
        isValid,
        touched,
        setErrors,
        handleChange,
        handleSubmit,
        isSubmitting,
        validateForm,
        setFieldError,
        setFieldValue,
        setFieldTouched,
      }) => (
        <form onSubmit={handleSubmit}>
          <div className='mb-5 mt-4 mx-lg-4 editProfileForm'>
            {
              width >=768
                ? (
                  <>
                    <div className='mb-5 formTabs'>
                      <button
                        type='button'
                        onClick={() => setFormTabs(1)}
                        className={`btn button2 ${formTabs === 1 && 'active'}`}
                      >
                        {t('jobseekerEditProfile.personalInformation')}
                      </button>
                      <button
                        type='button'
                        onClick={() => setFormTabs(2)}
                        className={`btn button2 ${formTabs === 2 && 'active'}`}
                        disabled={
                          errors.city ||
                          errors.gender ||
                          errors.country ||
                          errors.birthday ||
                          errors.last_name ||
                          errors.first_name ||
                          errors.middle_name
                        }
                      >
                        {t('jobseekerEditProfile.contactInformation')}
                      </button>
                      <button
                        type='button'
                        onClick={() => setFormTabs(3)}
                        className={`btn button2 ${formTabs === 3 && 'active'}`}
                        disabled={
                          errors.social_links ||
                          errors.email_address ||
                          errors.video_cv_link ||
                          errors.contact_number ||
                          errors.messenger_links ||
                          errors.contact_number_2 ||
                          errors.contact_number_3
                        }
                      >
                        {t('jobseekerEditProfile.desiredPosition')}
                      </button>
                      <button
                        type='button'
                        onClick={() => setFormTabs(4)}
                        className={`btn button2 ${formTabs === 4 && 'active'}`}
                        disabled={
                          errors.position ||
                          errors.work_type ||
                          errors.salary_max ||
                          errors.salary_min ||
                          errors.relocations ||
                          errors.desired_country ||
                          errors.salary_currency ||
                          errors.desired_category
                        }
                      >
                        {t('jobseekerEditProfile.workExperience')}
                      </button>
                      <button
                        type='button'
                        disabled={errors.experiences}
                        onClick={() => setFormTabs(5)}
                        className={`btn button2 ${formTabs === 5 && 'active'}`}
                      >
                        {t('jobseekerEditProfile.educationInfo')}
                      </button>
                      <button
                        type='button'
                        onClick={() => setFormTabs(6)}
                        className={`btn button2 ${formTabs === 6 && 'active'}`}
                        disabled={errors.educations || errors.additional_educations}
                      >
                        {t('jobseekerEditProfile.additionalInfo')}
                      </button>
                    </div>
                    {
                      formTabs === 1 && (
                        <PersonalInformationBlock
                          errors={errors}
                          values={values}
                          touched={touched}
                          setErrors={setErrors}
                          directories={directories}
                          handleChange={handleChange}
                          validateForm={validateForm}
                          setFieldError={setFieldError}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                        />
                      )
                    }
                    {
                      formTabs === 2 && (
                        <ContactInformationBlock
                          errors={errors}
                          values={values}
                          isAdmin={isAdmin}
                          touched={touched}
                          directories={directories}
                          handleChange={handleChange}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                        />
                      )
                    }
                    {
                      formTabs === 3 && (
                        <DesiredPositionBlock
                          errors={errors}
                          values={values}
                          touched={touched}
                          setErrors={setErrors}
                          directories={directories}
                          handleChange={handleChange}
                          setFieldError={setFieldError}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                        />
                      )
                    }
                    {
                      formTabs === 4 && (
                        <WorkExperienceBlock
                          errors={errors}
                          values={values}
                          touched={touched}
                          directories={directories}
                          handleChange={handleChange}
                          setFieldError={setFieldError}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                        />
                      )
                    }
                    {
                      formTabs === 5 && (
                        <EducationInfoBlock
                          errors={errors}
                          values={values}
                          touched={touched}
                          faculties={faculties}
                          directories={directories}
                          handleChange={handleChange}
                          setFaculties={setFaculties}
                          setFieldError={setFieldError}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                        />
                      )
                    }
                    {
                      formTabs === 6 && (
                        <AdditionalInfoBlock
                          errors={errors}
                          values={values}
                          touched={touched}
                          setErrors={setErrors}
                          directories={directories}
                          handleChange={handleChange}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                        />
                      )
                    }
                  </>
                )
                : (
                  <div className='mb-5 editProfileFormMobile'>
                    <div className='formTabsMobileBox'>
                      <button type='button' className='formTabsMobile' onClick={() => setFormTabs(1)}>
                        {t('jobseekerEditProfile.personalInformation')}
                        {
                          formTabs === 1
                            ? <i className='fa-solid fa-circle-minus'></i>
                            : <i className='fa-solid fa-circle-plus'></i>
                        }
                      </button>
                      {
                        formTabs === 1 && (
                          <div className='mt-3'>
                            <PersonalInformationBlock
                              errors={errors}
                              values={values}
                              touched={touched}
                              setErrors={setErrors}
                              directories={directories}
                              handleChange={handleChange}
                              validateForm={validateForm}
                              setFieldError={setFieldError}
                              setFieldValue={setFieldValue}
                              setFieldTouched={setFieldTouched}
                            />
                            <div className='mb-5 stepButtons'>
                              <button
                                type='button'
                                className='btn button2'
                                disabled={formTabs === 1}
                                onClick={() => handlePrevious()}
                              >
                                <ArrowBackIcon sx={{ mr: '8px' }} />
                                {t('jobseekerEditProfile.previous')}
                              </button>
                              <button
                                type='button'
                                className='btn button1'
                                disabled={formTabs === 6}
                                onClick={() => handleNext(errors, setFieldTouched)}
                              >
                                {t('jobseekerEditProfile.next')}
                                <ArrowForwardIcon sx={{ ml: '8px' }} />
                              </button>
                            </div>
                          </div>
                        )
                      }
                    </div>
                    <div className='formTabsMobileBox'>
                      <button
                        type='button'
                        className='formTabsMobile'
                        onClick={() => setFormTabs(2)}
                        disabled={
                          errors.city ||
                          errors.gender ||
                          errors.country ||
                          errors.birthday ||
                          errors.last_name ||
                          errors.first_name ||
                          errors.middle_name
                        }
                      >
                        {t('jobseekerEditProfile.contactInformation')}
                        {
                          formTabs === 2
                            ? <i className='fa-solid fa-circle-minus'></i>
                            : <i className='fa-solid fa-circle-plus'></i>
                        }
                      </button>
                      {
                        formTabs === 2 && (
                          <div className='mt-3'>
                            <ContactInformationBlock
                              errors={errors}
                              values={values}
                              isAdmin={isAdmin}
                              touched={touched}
                              directories={directories}
                              handleChange={handleChange}
                              setFieldValue={setFieldValue}
                              setFieldTouched={setFieldTouched}
                            />
                            <div className='mb-5 stepButtons'>
                              <button
                                type='button'
                                className='btn button2'
                                disabled={formTabs === 1}
                                onClick={() => handlePrevious()}
                              >
                                <ArrowBackIcon sx={{ mr: '8px' }} />
                                {t('jobseekerEditProfile.previous')}
                              </button>
                              <button
                                type='button'
                                className='btn button1'
                                disabled={formTabs === 6}
                                onClick={() => handleNext(errors, setFieldTouched)}
                              >
                                {t('jobseekerEditProfile.next')}
                                <ArrowForwardIcon sx={{ ml: '8px' }} />
                              </button>
                            </div>
                          </div>
                        )
                      }
                    </div>
                    <div className='formTabsMobileBox'>
                      <button
                        type='button'
                        className='formTabsMobile'
                        onClick={() => setFormTabs(3)}
                        disabled={
                          errors.social_links ||
                          errors.email_address ||
                          errors.video_cv_link ||
                          errors.contact_number ||
                          errors.messenger_links ||
                          errors.contact_number_2 ||
                          errors.contact_number_3
                        }
                      >
                        {t('jobseekerEditProfile.desiredPosition')}
                        {
                          formTabs === 3
                            ? <i className='fa-solid fa-circle-minus'></i>
                            : <i className='fa-solid fa-circle-plus'></i>
                        }
                      </button>
                      {
                        formTabs === 3 && (
                          <div className='mt-3'>
                            <DesiredPositionBlock
                              errors={errors}
                              values={values}
                              touched={touched}
                              setErrors={setErrors}
                              directories={directories}
                              handleChange={handleChange}
                              setFieldError={setFieldError}
                              setFieldValue={setFieldValue}
                              setFieldTouched={setFieldTouched}
                            />
                            <div className='mb-5 stepButtons'>
                              <button
                                type='button'
                                className='btn button2'
                                disabled={formTabs === 1}
                                onClick={() => handlePrevious()}
                              >
                                <ArrowBackIcon sx={{ mr: '8px' }} />
                                {t('jobseekerEditProfile.previous')}
                              </button>
                              <button
                                type='button'
                                className='btn button1'
                                disabled={formTabs === 6}
                                onClick={() => handleNext(errors, setFieldTouched)}
                              >
                                {t('jobseekerEditProfile.next')}
                                <ArrowForwardIcon sx={{ ml: '8px' }} />
                              </button>
                            </div>
                          </div>
                        )
                      }
                    </div>
                    <div className='formTabsMobileBox'>
                      <button
                        type='button'
                        className='formTabsMobile'
                        onClick={() => setFormTabs(4)}
                        disabled={
                          errors.position ||
                          errors.work_type ||
                          errors.salary_max ||
                          errors.salary_min ||
                          errors.relocations ||
                          errors.desired_country ||
                          errors.salary_currency ||
                          errors.desired_category
                        }
                      >
                        {t('jobseekerEditProfile.workExperience')}
                        {
                          formTabs === 4
                            ? <i className='fa-solid fa-circle-minus'></i>
                            : <i className='fa-solid fa-circle-plus'></i>
                        }
                      </button>
                      {
                        formTabs === 4 && (
                          <div className='mt-3'>
                            <WorkExperienceBlock
                              errors={errors}
                              values={values}
                              touched={touched}
                              directories={directories}
                              handleChange={handleChange}
                              setFieldError={setFieldError}
                              setFieldValue={setFieldValue}
                              setFieldTouched={setFieldTouched}
                            />
                            <div className='mb-5 stepButtons'>
                              <button
                                type='button'
                                className='btn button2'
                                disabled={formTabs === 1}
                                onClick={() => handlePrevious()}
                              >
                                <ArrowBackIcon sx={{ mr: '8px' }} />
                                {t('jobseekerEditProfile.previous')}
                              </button>
                              <button
                                type='button'
                                className='btn button1'
                                disabled={formTabs === 6}
                                onClick={() => handleNext(errors, setFieldTouched)}
                              >
                                {t('jobseekerEditProfile.next')}
                                <ArrowForwardIcon sx={{ ml: '8px' }} />
                              </button>
                            </div>
                          </div>
                        )
                      }
                    </div>
                    <div className='formTabsMobileBox'>
                      <button
                        type='button'
                        className='formTabsMobile'
                        disabled={errors.experiences}
                        onClick={() => setFormTabs(5)}
                      >
                        {t('jobseekerEditProfile.educationInfo')}
                        {
                          formTabs === 5
                            ? <i className='fa-solid fa-circle-minus'></i>
                            : <i className='fa-solid fa-circle-plus'></i>
                        }
                      </button>
                      {
                        formTabs === 5 && (
                          <div className='mt-3'>
                            <EducationInfoBlock
                              errors={errors}
                              values={values}
                              touched={touched}
                              faculties={faculties}
                              directories={directories}
                              handleChange={handleChange}
                              setFaculties={setFaculties}
                              setFieldError={setFieldError}
                              setFieldValue={setFieldValue}
                              setFieldTouched={setFieldTouched}
                            />
                            <div className='mb-5 stepButtons'>
                              <button
                                type='button'
                                className='btn button2'
                                disabled={formTabs === 1}
                                onClick={() => handlePrevious()}
                              >
                                <ArrowBackIcon sx={{ mr: '8px' }} />
                                {t('jobseekerEditProfile.previous')}
                              </button>
                              <button
                                type='button'
                                className='btn button1'
                                disabled={formTabs === 6}
                                onClick={() => handleNext(errors, setFieldTouched)}
                              >
                                {t('jobseekerEditProfile.next')}
                                <ArrowForwardIcon sx={{ ml: '8px' }} />
                              </button>
                            </div>
                          </div>
                        )
                      }
                    </div>
                    <div className='formTabsMobileBox'>
                      <button
                        type='button'
                        className='formTabsMobile'
                        onClick={() => setFormTabs(6)}
                        disabled={errors.educations || errors.additional_educations}
                      >
                        {t('jobseekerEditProfile.additionalInfo')}
                        {
                          formTabs === 6
                            ? <i className='fa-solid fa-circle-minus'></i>
                            : <i className='fa-solid fa-circle-plus'></i>
                        }
                      </button>
                      {
                        formTabs === 6 && (
                          <div className='mt-3'>
                            <AdditionalInfoBlock
                              errors={errors}
                              values={values}
                              touched={touched}
                              setErrors={setErrors}
                              directories={directories}
                              handleChange={handleChange}
                              setFieldValue={setFieldValue}
                              setFieldTouched={setFieldTouched}
                            />
                            <div className='mb-5 stepButtons'>
                              <button
                                type='button'
                                className='btn button2'
                                disabled={formTabs === 1}
                                onClick={() => handlePrevious()}
                              >
                                <ArrowBackIcon sx={{ mr: '8px' }} />
                                {t('jobseekerEditProfile.previous')}
                              </button>
                              <button
                                type='button'
                                className='btn button1'
                                disabled={formTabs === 6}
                                onClick={() => handleNext(errors, setFieldTouched)}
                              >
                                {t('jobseekerEditProfile.next')}
                                <ArrowForwardIcon sx={{ ml: '8px' }} />
                              </button>
                            </div>
                          </div>
                        )
                      }
                    </div>
                  </div>
                )
            }
            {
              width >= 768 && (
                <div className='mb-5 stepButtons'>
                  <button
                    type='button'
                    className='btn button2'
                    disabled={formTabs === 1}
                    onClick={() => handlePrevious()}
                  >
                    <ArrowBackIcon sx={{ mr: '8px' }} />
                    {t('jobseekerEditProfile.previous')}
                  </button>
                  <button
                    type='button'
                    className='btn button1'
                    disabled={formTabs === 6}
                    onClick={() => handleNext(errors, setFieldTouched)}
                  >
                    {t('jobseekerEditProfile.next')}
                    <ArrowForwardIcon sx={{ ml: '8px' }} />
                  </button>
                </div>
              )
            }
            <div className='bottomButtons'>
              {/* <PrimaryButton
                t={t}
                id={id}
                isCopy={isCopy}
                values={values}
                isAdmin={isAdmin}
                isValid={isValid}
                onCreate={handleCreate}
                isSubmitting={isSubmitting}
              /> */}
              {
                !id ? (
                  <button
                    type='button'
                    className='btn btn-primary button1'
                    disabled={!isValid || isSubmitting}
                    onClick={() => handleCreate(values)}
                  >
                    {t('jobseekerEditProfile.createCVButton')}
                  </button>
                ) : (
                  isCopy ? (
                    <button
                      type='button'
                      className='btn btn-primary button1'
                      disabled={!isValid || isSubmitting}
                      onClick={() => handleCreate(values)}
                    >
                      {t('jobseekerEditProfile.createCVButton')}
                    </button>
                  ) : (
                    <button
                      type='submit'
                      className='btn btn-primary button1'
                      disabled={!isValid || isSubmitting}
                    >
                      {t('jobseekerEditProfile.updateButton')}
                    </button>
                  )
                )
              }
              <button
                type='button'
                disabled={isSubmitting}
                className='btn btn-primary button2'
                onClick={step === 'createResume' ? () => setStep('jobApplySelect') : () => navigate(-1)}
              >
                {t('jobseekerEditProfile.cancelButton')}
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default JSEditProfileForm;
